import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface CreditBadgeProps {
  balanceCents: number;
  className?: string;
}

export default function CreditBadge({ balanceCents, className }: CreditBadgeProps) {
  const balanceDollars = (balanceCents / 100).toFixed(2);

  return (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-semibold",
        theme.colors.primaryOrange,
        theme.borders.neubrutalism,
        "text-gray-900 dark:text-white",
        className,
      )}
    >
      <span>💰</span>
      <span>${balanceDollars}</span>
    </div>
  );
}



